import generatePasswordResetToken from './generatePasswordResetToken';

export default generatePasswordResetToken;
